import dot from 'dot-prop-immutable';
import { denormalize } from 'normalizr';
import reduceReducers from 'reduce-reducers';

import { createEntitiesReducer } from 'modules/common/redux';
import { FORMULA_COMPILE_SUCCESS_MSG } from 'modules/constants/common/all';

import { formatTimestamp } from 'utils/dateUtils';

import { types } from './actions';
import { addOnDefSchema, variableSchema } from './entities';

const initialState = {
  addOnId: null,
  entities: {},
  formulaEditor: {
    isModalOpen: false,
    isUpdating: false,
    isCompiling: false,
    message: null,
    error: false,
  },
  isDeletingAddOn: false,
};

const entitiesReducer = createEntitiesReducer(
  ['addOnDefs', 'variables'],
  [
    types.RECEIVE_ADD_ON,
    types.UPDATE_ADD_ON_SUCCESS,
    types.UPDATE_VARIABLE_SUCCESS,
  ],
);

const reducer = (state, action) => {
  const { payload, type } = action;
  switch (type) {
    case types.ADD_ON_DETAILS_PAGE_INIT:
      return {
        ...initialState,
      };
    case types.DELETE_ADD_ON_ERROR:
    case types.DELETE_ADD_ON_SUCCESS:
      return {
        ...state,
        isDeletingAddOn: false,
      };
    case types.DELETE_ADD_ON_REQUEST:
      return {
        ...state,
        isDeletingAddOn: true,
      };
    case types.FORMULA_OPEN_MODAL:
      return dot.merge(state, 'formulaEditor', {
        isModalOpen: true,
      });
    case types.FORMULA_CLOSE_MODAL:
      return dot.merge(state, 'formulaEditor', {
        isModalOpen: false,
        message: null,
        error: false,
      });
    case types.FORMULA_COMPILE_REQUEST:
      return dot.merge(state, 'formulaEditor', {
        isCompiling: true,
      });
    case types.FORMULA_COMPILE_SUCCESS:
      return dot.merge(state, 'formulaEditor', {
        isCompiling: false,
        message: FORMULA_COMPILE_SUCCESS_MSG,
        error: false,
      });
    case types.FORMULA_COMPILE_ERROR:
      return dot.merge(state, 'formulaEditor', {
        isCompiling: false,
        message: action.payload.error,
        error: true,
      });
    case types.FORMULA_UPDATE_REQUEST:
      return dot.merge(state, 'formulaEditor', {
        isUpdating: true,
      });
    case types.FORMULA_UPDATE_SUCCESS: {
      let nextState = state;
      nextState = dot.merge(
        nextState,
        `entities.processes.${action.payload.processId}.opFactoryFormula`,
        action.payload.formula,
      );
      const savedMsg = action.payload.formula.revertedFrom
        ? `Restored from: ${formatTimestamp(
            action.payload.formula.revertedFrom,
          )}`
        : 'Saved';
      nextState = dot.merge(nextState, 'formulaEditor', {
        isUpdating: false,
        error: false,
        message: savedMsg,
      });
      return nextState;
    }
    case types.FORMULA_UPDATE_ERROR:
      return dot.merge(state, 'formulaEditor', {
        isUpdating: false,
        message: action.payload.error,
        error: true,
      });
    case types.FORMULA_RESET_MESSAGE:
      return dot.merge(state, 'formulaEditor', {
        message: '',
        error: false,
      });
    case types.RECEIVE_ADD_ON:
      return {
        ...state,
        addOnId: payload.result,
      };
    default:
      return state;
  }
};

export default reduceReducers(entitiesReducer, reducer, initialState);

const getScope = (state) => state.modules.addOns.detailsPage;

export const getAddOnId = (state) => getScope(state).addOnId;

export const getAddOn = (state) =>
  denormalize(getAddOnId(state), addOnDefSchema, getScope(state).entities);

export const getFormulaEditorState = (state) => getScope(state).formulaEditor;

export const getVariable = (state, variableId) =>
  denormalize(variableId, variableSchema, getScope(state).entities);

export const isDeletingAddOn = (state) => getScope(state).isDeletingAddOn;
